import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=1edc371b&scoped=true&"
import script from "./Restaurant.vue?vue&type=script&lang=ts&"
export * from "./Restaurant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc371b",
  null
  
)

export default component.exports